import axios from "axios";

import moment from "moment";
import "moment-timezone";

const SPACE = " ";
export default {
  async auditErrorFrontent(data) {
    //let ip = this.getMeIp();
    data.requestIp = null;
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/audit/error",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  async auditActivity(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/audit/activity",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getVersion() {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "public/version",
    });
  },
  getMeIp() {
    return axios({
      method: "get",
      url: "https://api.ipify.org?format=json",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  sendConfirmation(email) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "public/user/send/activate/" +
        email,
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  sendNewPassword(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "public/password/reset",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  sendPasswordForgot(email) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE + "public/password/forgot/" + email,
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  checkEmailPatientProfessional(email, professionalId) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "public/professional/" +
        professionalId +
        "/email/check/" +
        email,
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  checkEmailPatientOrganization(email, organizationId) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "public/organization/" +
        organizationId +
        "/email/check/" +
        email,
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  checkEmail(email) {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "public/email/check/" + email,
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  getPing() {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "public/ping",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  getCountrys(data) {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "public/countrys",
      headers: {
        "X-CSRF-TOKEN": "",
      },
    });
  },
  inputNotEmpty(value) {
    return /([^\s])/.test(value);
  },
  getFile(uuid) {
    if (uuid) {
      return axios({
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL_CORE +
          "public/file/" +
          uuid +
          "/" +
          localStorage.getItem("authorization"),
        headers: {
          "X-CSRF-TOKEN": "",
        },
      });
    } else {
      return Promise.resolve("ok");
    }
  },
  getFileStream(uuid) {
    if (uuid) {
      return axios({
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL_CORE +
          "public/file/" +
          uuid +
          "/streaming/" +
          localStorage.getItem("authorization"),
        headers: {
          "X-CSRF-TOKEN": "",
        },
      });
    } else {
      return Promise.resolve("ok");
    }
  },
  b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  },
  urlToB64(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  },
  createFile(data) {
    return axios({
      method: "post",
      url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
      data: data,
      headers: {
        "X-CSRF-TOKEN": "",
        "Content-Type": "multipart/form-data",
      },
    });
  },
  b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  },
  generateJsonFields(array) {
    let stringStartObject = "{ ";
    let stringEndObject = " }";

    let jsonString = "" + stringStartObject;

    array.forEach(function (valor, indice) {
      if (indice !== 0) {
        jsonString = jsonString + ", ";
      }
      let objectJsonFieldsString =
        '"' + valor.key + '" : "' + valor.value + '"';

      jsonString = jsonString + objectJsonFieldsString;
    });

    jsonString = jsonString + stringEndObject;

    return JSON.parse(jsonString);
  },
  checkPermissionProfessional(permissionParam, permissionTypeParams) {
    let response = JSON.parse(localStorage.getItem("organizationRoles"));
    let role = localStorage.getItem("role");

    if (role === "PROFESSIONAL") {
      //Roles
      if (response) {
        let exist = false;
        response.forEach(function (role) {
          if (role) {
            role.permissions.forEach(function (permission) {
              if (
                permissionParam === permission.permission &&
                permission.permissionTypes
              ) {
                permission.permissionTypes.forEach(function (permissionType) {
                  permissionTypeParams.forEach(function (permissionTypeParam) {
                    if (
                      permissionType.type === permissionTypeParam &&
                      permissionType.active
                    ) {
                      exist = true;
                    }
                  });
                });
              }
            });
          }
        });
        return exist;
      }
    } else {
      return true;
    }
  },
  transformNumberToHour(i) {
    if (i === 0) {
      return "00:00";
    }
    if (i === 1) {
      return "01:00";
    }
    if (i === 2) {
      return "02:00";
    }
    if (i === 3) {
      return "03:00";
    }
    if (i === 4) {
      return "04:00";
    }
    if (i === 5) {
      return "05:00";
    }
    if (i === 6) {
      return "06:00";
    }
    if (i === 7) {
      return "07:00";
    }
    if (i === 8) {
      return "08:00";
    }
    if (i === 9) {
      return "09:00";
    }
    if (i === 10) {
      return "10:00";
    }
    if (i === 11) {
      return "11:00";
    }
    if (i === 12) {
      return "12:00";
    }
    if (i === 13) {
      return "13:00";
    }
    if (i === 14) {
      return "14:00";
    }
    if (i === 15) {
      return "15:00";
    }
    if (i === 16) {
      return "16:00";
    }
    if (i === 17) {
      return "17:00";
    }
    if (i === 18) {
      return "18:00";
    }
    if (i === 19) {
      return "19:00";
    }
    if (i === 20) {
      return "20:00";
    }
    if (i === 21) {
      return "21:00";
    }
    if (i === 22) {
      return "22:00";
    }
    if (i === 23) {
      return "23:00";
    }
  },
  getLocalTimezoneOption() {
    return moment.tz.guess();
  },
  adjustDateTimeInverse(value, customFormat) {
    if (!value) return "";

    const formatInput = "YYYY-MM-DDTHH:mm:ss";
    const formatOuput = customFormat || "DD/MM/YYYY HH:mm";
    const selectedTimezone = localStorage.getItem("timeZone");


    const brusselsMoment = moment.tz(value,formatInput, "Europe/Brussels");

    // Convert the Moment object to the timezone "Europe/Brussels"
    const adjustedMoment = brusselsMoment.clone().tz(selectedTimezone);
   
    return adjustedMoment.format(formatOuput);
  },
  adjustDateTimeClock(value, customFormat) {
    if (!value) return "";
  
    const defaultFormat = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]";
    const format = customFormat || defaultFormat;
    const selectedTimezone = localStorage.getItem("timeZone");
  
    // Crear un objeto Moment con la zona horaria almacenada
    const adjustedMoment = moment.tz(value, selectedTimezone);
    
    // Devolver el valor formateado
    return adjustedMoment.format(format);
  },

  adjustDateTime(value, customFormat) {
    if (!value) return "";

    const formatInput = "DD/MM/YYYY HH:mm";
    const formatOuput = customFormat || "DD/MM/YYYY HH:mm";
    const selectedTimezone = localStorage.getItem("timeZone");

    // Create a Moment object with the date and time entered in the selected timezone
    const localMoment = moment.tz(value, formatInput, selectedTimezone);

    // Convert the Moment object to the timezone "Europe/Brussels"
    const brusselsMoment = localMoment.clone().tz("Europe/Brussels");

    // Return the adjusted value in the desired format
    return brusselsMoment.format(formatOuput);
}
  
};
